import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Form, TextArea, Grid, Input, Dropdown } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Addaddress extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit = () => {
    let context = this;
    let address = this.state.address;
    let taluk = this.state.taluk;
    let district = this.state.district;
    let state = this.state.state;
    let pincode = this.state.pincode;
    let gstin = this.state.gstin;
    let cid = this.props.cid;
    if (address == '' || address == undefined || address == null) {
      alert('Enter address!!!'); return;
    }
    if (taluk == '' || taluk == undefined || taluk == null) {
      alert('Enter taluk!!!'); return;
    }
    if (district == '' || district == undefined || district == null) {
      alert('Enter district!!!'); return;
    }
    if (state == '' || state == undefined || state == null) {
      alert('Enter state!!!'); return;
    }
    if (pincode == '' || pincode == undefined || pincode == null) {
      alert('Enter pincode!!!'); return;
    }
    if (gstin == '' || gstin == undefined || gstin == null) {
      alert('Enter gstin!!!'); return;
    }
    let data1 = { 'address': address, 'taluk': taluk, 'district': district, 'state': state, 'pincode': pincode, 'gstin': gstin, 'cid': cid };
    if (this.props.type == 'edit') {
      data1 = { 'address': address, 'taluk': taluk, 'district': district, 'state': state, 'pincode': pincode, 'gstin': gstin, 'cid': cid, 'id': cid };
    }
    this.setState({ load: true, message: 'Adding Address!!!' })
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'machinecustomer/addaddress.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        if (data == 1) {
          context.setState({ open: false, address: '', taluk: '', district: '', state: '', pincode: '', gstin: '' })
          context.props.getAddress();
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  openDialog() {
    this.setState({
      open: true,
      address: this.props.data.address,
      taluk: this.props.data.taluk,
      district: this.props.data.district,
      state: this.props.data.state,
      pincode: this.props.data.pincode,
      gstin: this.props.data.GSTIN,
    });
  }

  statesChnage = (f, { value }) => {
    this.setState({ state: value });
  }

  render() {
    const { classes } = this.props;
    let menu = [
      { key: 'Tamil Nadu', text: 'Tamil Nadu', value: 'Tamil Nadu' },
      { key: 'Karnataka', text: 'Karnataka', value: 'Karnataka' },
      { key: 'Kerala', text: 'Kerala', value: 'Kerala' },
      { key: 'Andhra Pradesh', text: 'Andhra Pradesh', value: 'Andhra Pradesh' },
    ];
    return (
      <React.Fragment>
        <Loading load={this.state.load} message={this.state.message} />
        { this.props.type == 'add' ?
          (
            <Fab variant="extended" size="medium" color="primary" aria-label="Add"
                onClick={ () => { this.setState({ open: true }) }}>
              <AddIcon />
              Add Address
            </Fab>
          ):
          (
            <div onClick={this.openDialog.bind(this)}>Edit</div>
          )
        }
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth} open={this.state.open}
          onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Add Address</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                Address<br/>
                <Form>
                  <TextArea placeholder='Address' focus onChange={this.handleChange('address')}
                  value={this.state.address} />
                </Form>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                Taluk<br/>
                <Input focus onChange={this.handleChange('taluk')} value={this.state.taluk} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                District<br/>
                <Input focus onChange={this.handleChange('district')} value={this.state.district} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                State<br/>
                <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
                 fluid search selection onChange={this.statesChnage} fluid
                 options={menu} value={this.state.state} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Pincode<br/>
                <Input focus fluid onChange={this.handleChange('pincode')} value={this.state.pincode} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                GSTN<br/>
                <Input focus fluid onChange={this.handleChange('gstin')} value={this.state.gstin} />
              </Grid.Column>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit} color="primary">
              Submit
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

Addaddress.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Addaddress);
